import { createFileRoute } from '@tanstack/react-router';
import { ConversationPage } from '@/components/ai/conversation-page';

export const Route = createFileRoute('/_app/ai/$conversationId')({
  // The task shown in the panel; optional so plain links to a conversation need no search.
  validateSearch: (search: Record<string, unknown>): { task?: string } => ({
    task: typeof search.task === 'string' ? search.task : undefined,
  }),
  component: ConversationRoute,
});

function ConversationRoute() {
  const { conversationId } = Route.useParams();
  const { task } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    // Keyed: a different conversation is a fresh page (its own stream and state).
    <ConversationPage
      key={conversationId}
      id={conversationId}
      selectedTask={task ?? null}
      onSelectTask={(t) =>
        void navigate({ search: (s) => ({ ...s, task: t ?? undefined }), replace: true })
      }
    />
  );
}
